<div class="modal-header">
  <h4 class="modal-title">Manage Topics</h4>
  <button type="button" class="close" (click)="onCancel()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">
  <!-- Topics List -->
  <div *ngIf="!showAddForm">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Existing Topics</h5>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        (click)="showAddTopicForm()">
        <i class="fa fa-plus"></i> Add New Topic
      </button>
    </div>

    <div class="table-responsive" *ngIf="topics.length > 0">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Topic Name</th>
            <th>Status</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let topic of topics">
            <td>{{ topic.topic_name }}</td>
            <td>
              <span 
                class="badge"
                [class.bg-success]="topic.status"
                [class.bg-danger]="!topic.status">
                {{ topic.status ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>{{ topic.created_date | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>
              <button
                class="action-btn"
                (click)="editTopic(topic)"
                title="Edit Topic">
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="action-btn"
                (click)="deleteTopic(topic)"
                title="Delete Topic">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="no-records" *ngIf="topics.length === 0">
      <p>No topics available. Click "Add New Topic" to create one.</p>
    </div>
  </div>

  <!-- Add/Edit Form -->
  <div *ngIf="showAddForm">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">{{ editingTopic ? 'Edit Topic' : 'Add New Topic' }}</h5>
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="cancelEdit()">
        <i class="fa fa-arrow-left"></i> Back to List
      </button>
    </div>

    <form [formGroup]="topicForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="topic_name">Topic Name *</label>
        <input
          type="text"
          id="topic_name"
          class="form-control"
          formControlName="topic_name"
          placeholder="Enter topic name"
          [class.is-invalid]="topicForm.get('topic_name')?.invalid && topicForm.get('topic_name')?.touched">
        <div class="invalid-feedback" *ngIf="getFieldError('topic_name')">
          {{ getFieldError('topic_name') }}
        </div>
      </div>

      <div class="mb-3" *ngIf="editingTopic">
        <div class="form-check">
          <input
            type="checkbox"
            id="status"
            class="form-check-input"
            formControlName="status">
          <label class="form-check-label" for="status">
            Active
          </label>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="onCancel()"
    [disabled]="loading">
    Close
  </button>
  <button
    *ngIf="showAddForm"
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
    [disabled]="loading || topicForm.invalid">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
    {{ editingTopic ? 'Update Topic' : 'Add Topic' }}
  </button>
</div>
